import { render, staticRenderFns } from "./commentDetailDialog.vue?vue&type=template&id=1394260c&scoped=true"
import script from "./commentDetailDialog.vue?vue&type=script&lang=ts"
export * from "./commentDetailDialog.vue?vue&type=script&lang=ts"
import style0 from "./commentDetailDialog.vue?vue&type=style&index=0&id=1394260c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1394260c",
  null
  
)

export default component.exports